import { ChatNetworkingFastComponent } from './chat-networking-fast/chat-networking-fast.component';
import { ModalPendingMessagesNetworkingComponent } from './modal-pending-messages-networking/modal-pending-messages-networking.component';
import { NetworkingPage } from './networking/networking.page';

export const PAGES = [
  NetworkingPage,
  ChatNetworkingFastComponent,
  ModalPendingMessagesNetworkingComponent
];
